import FilterConstants from '../../filter-constants';

const _capacitorToleranceList = [
  { text: 'settings.tolerances.one', value: FilterConstants.capacitorTolerance.one },
  { text: 'settings.tolerances.five', value: FilterConstants.capacitorTolerance.five },
  { text: 'settings.tolerances.ten', value: FilterConstants.capacitorTolerance.ten },
  { text: 'settings.tolerances.twenty', value: FilterConstants.capacitorTolerance.twenty },
  { text: 'settings.tolerances.ideal', value: FilterConstants.capacitorTolerance.ideal },
];
const _resistorToleranceList = [
  { text: 'settings.tolerances.oneTenth', value: FilterConstants.resistorTolerance.oneTenth },
  { text: 'settings.tolerances.fiveTenths', value: FilterConstants.resistorTolerance.fiveTenths },
  { text: 'settings.tolerances.one', value: FilterConstants.resistorTolerance.one },
  { text: 'settings.tolerances.five', value: FilterConstants.resistorTolerance.five },
  { text: 'settings.tolerances.ideal', value: FilterConstants.resistorTolerance.ideal },
];
const _inductorToleranceList = [
  { text: 'settings.tolerances.five', value: FilterConstants.inductorTolerance.five },
  { text: 'settings.tolerances.ten', value: FilterConstants.inductorTolerance.ten },
  { text: 'settings.tolerances.twenty', value: FilterConstants.inductorTolerance.twenty },
  { text: 'settings.tolerances.ideal', value: FilterConstants.inductorTolerance.ideal },
];
const _opAmpGbwToleranceList = [
  { text: 'settings.tolerances.twenty', value: FilterConstants.gbwTolerance.twenty },
  { text: 'settings.tolerances.ideal', value: FilterConstants.gbwTolerance.ideal },
];
const _capacitorPreferredSeriesList = [
  { text: 'settings.tolerances.E6', value: FilterConstants.eSeries.E6 },
  { text: 'settings.tolerances.E12', value: FilterConstants.eSeries.E12 },
  { text: 'settings.tolerances.E24', value: FilterConstants.eSeries.E24 },
  { text: 'settings.tolerances.ideal', value: FilterConstants.eSeries.ideal },
];
const _resistorPreferredSeriesList = [
  { text: 'settings.tolerances.E6', value: FilterConstants.eSeries.E6 },
  { text: 'settings.tolerances.E12', value: FilterConstants.eSeries.E12 },
  { text: 'settings.tolerances.E24', value: FilterConstants.eSeries.E24 },
  { text: 'settings.tolerances.E48', value: FilterConstants.eSeries.E48 },
  { text: 'settings.tolerances.E96', value: FilterConstants.eSeries.E96 },
  { text: 'settings.tolerances.ideal', value: FilterConstants.eSeries.ideal },
];
const _inductorPreferredSeriesList = [
  { text: 'settings.tolerances.E6', value: FilterConstants.eSeries.E6 },
  { text: 'settings.tolerances.E12', value: FilterConstants.eSeries.E12 },
  { text: 'settings.tolerances.E24', value: FilterConstants.eSeries.E24 },
  { text: 'settings.tolerances.ideal', value: FilterConstants.eSeries.ideal },
];

export default class ToleranceInput {
  capacitorToleranceList;
  resistorToleranceList;
  inductorToleranceList;
  opAmpGbwToleranceList;
  capacitorPreferredSeriesList;
  resistorPreferredSeriesList;
  inductorPreferredSeriesList;

  capacitorTolerance;
  resistorTolerance;
  inductorTolerance;
  opAmpGbwTolerance;
  capacitorPreferredSeries;
  resistorPreferredSeries;
  inductorPreferredSeries;

  constructor(args) {
    this.capacitorToleranceList = _capacitorToleranceList;
    this.resistorToleranceList = _resistorToleranceList;
    this.inductorToleranceList = _inductorToleranceList;
    this.opAmpGbwToleranceList = _opAmpGbwToleranceList;
    this.capacitorPreferredSeriesList = _capacitorPreferredSeriesList;
    this.resistorPreferredSeriesList = _resistorPreferredSeriesList;
    this.inductorPreferredSeriesList = _inductorPreferredSeriesList;

    if (args) {
      this.capacitorTolerance = args.capacitorTolerance ?? null;
      this.resistorTolerance = args.resistorTolerance ?? null;
      this.inductorTolerance = args.inductorTolerance ?? null;
      this.opAmpGbwTolerance = args.opAmpGbwTolerance ?? null;
      this.capacitorPreferredSeries = args.capacitorPreferredSeries ?? null;
      this.resistorPreferredSeries = args.resistorPreferredSeries ?? null;
      this.inductorPreferredSeries = args.inductorPreferredSeries ?? null;
    }
  }
}
